<template>
  <div class="createproject">
    <!-- <div class="section-title">Informacje o projekcie:</div> -->
    <b-form-group
      label=""
      label-cols-lg="3"
      label-for="projectType"
      v-if="!form.id && !form.parent_id"
    >
      <b-form-checkbox
        id="projectType"
        name="ismainproject"
        :checked="isMainProject"
        @change="
          (checked) => {
            this.$emit('toggleMainProject', checked);
          }
        "
      >
        Projekt z podbudowami
      </b-form-checkbox>
    </b-form-group>
    <b-form-group
      label="Kolor:"
      label-cols-lg="3"
      label-for="color"
      label-class=" text-lg-right"
      v-if="isMainProject === true"
    >
      <b-form-input
        id="color"
        v-model="form.color"
        type="color"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Nazwa:"
      label-cols-lg="3"
      label-for="projectName"
      label-class=" text-lg-right"
    >
      <ValidationProvider
        name="name"
        rules="required|max:191"
        v-slot="validationContext"
      >
        <b-form-input
          id="projectName"
          placeholder="wprowadź nazwę budowy"
          class="title-input"
          v-model="form.name"
          type="text"
        ></b-form-input>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>

    <b-form-group
      v-if="!form.parent_name"
      label="Firma:"
      label-cols-lg="3"
      label-class=" text-lg-right"
      label-for="company_id"
    >
      <ValidationProvider
        name="company_id"
        rules="required"
        v-slot="validationContext"
      >
        <b-form-select
          v-model="form.company_id"
          :options="items"
          options-field=""
          value-field="id"
          text-field="name"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >-- Please select an option --</b-form-select-option
            >
          </template>
        </b-form-select>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>

    <b-form-group
      label="Kierownik:"
      label-cols-lg="3"
      label-class=" text-lg-right"
      label-for="user_id"
    >
      <div class="d-flex align-items-center h-100" v-if="employeesLoading">
        <b-spinner small class="mx-2"></b-spinner>
        <small>Wczytuje...</small>
      </div>
      <ValidationProvider
        name="user_id"
        rules="required"
        v-slot="validationContext"
      >
        <b-form-select
          v-model="form.user_id"
          :options="availableEmployees('onlyEmployee')"
          v-show="!employeesLoading"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >-- Please select an option --</b-form-select-option
            >
          </template>
        </b-form-select>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>
    <b-form-group
      label="Klient:"
      label-cols-lg="3"
      label-class="text-lg-right"
      label-for="customer"
      v-if="!form.parent_id"
    >
      <div class="d-flex align-items-center h-100" v-if="customersLoading">
        <b-spinner small class="mx-2"></b-spinner>
        <small>Wczytuje...</small>
      </div>
      <ValidationProvider
        name="customer"
        rules="required"
        v-slot="validationContext"
      >
        <b-form-select
          v-model="form.customer_id"
          :options="availableCustomers"
          v-show="!customersLoading"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >-- Please select an option --</b-form-select-option
            >
          </template>
        </b-form-select>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>
    <b-form-group
      label="PUR:"
      label-cols-lg="3"
      label-class=" text-lg-right"
      label-for="pur"
    >
      <ValidationProvider name="pur" rules="max:100" v-slot="validationContext">
        <b-form-input id="pur" v-model="form.pur" type="text"></b-form-input>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>
    <b-form-group
      label="Adres:"
      label-cols-lg="3"
      label-class=" text-lg-right"
      label-for="address"
    >
      <ValidationProvider
        name="address"
        rules="required|max:191|min:3"
        v-slot="validationContext"
      >
        <b-form-input
          id="address"
          v-model="form.address"
          type="text"
        ></b-form-input>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>
    <b-form-group
      label="Planowana data rozpoczęcia:"
      label-cols-lg="3"
      label-class=" text-lg-right"
      label-for="planned_start_date"
    >
      <ValidationProvider
        name="planned_start_date"
        rules="required|max:191|min:3"
        v-slot="validationContext"
      >
        <v-date-picker
          class="datepicker"
          id="planned_start_date"
          v-model="form.planned_start_date"
          :locale="dateFormat"
          :popover="{ visibility: 'click' }"
          :masks="{ input: 'YYYY-MM-DD' }"
        ></v-date-picker>
        <b-form-invalid-feedback
          :state="getValidationState(validationContext)"
          >{{ validationContext.errors[0] }}</b-form-invalid-feedback
        >
      </ValidationProvider>
    </b-form-group>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import { randomColor } from "@/services/helpers";

export default {
  name: "ConstructionFormInfo",
  props: {
    form: {
      type: Object,
    },
    isMainProject: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      dateFormat: navigator.language,
      customersLoading: true,
      employeesLoading: true,
    };
  },
  computed: {
    isSubcontractor() {
      return this.getRole === "subcontractor";
    },
    ...mapGetters("user", ["getRole", "hasAccess"]),
    ...mapGetters("app", ["availableCustomers", "availableEmployees"]),
    ...mapGetters("company", ["items"]),
  },
  mounted() {
    if (!this.form.color && !this.form.id && !this.form.parent_id) {
      this.form.color = randomColor();
    }
    if (this.isSubcontractor === false) {
      this.loadAvailableCustomers().then(() => {
        this.customersLoading = false;
      });
      this.loadAvailableEmployees().then(() => {
        this.employeesLoading = false;
      });
    }
  },
  methods: {
    ...mapActions("app", ["loadAvailableCustomers", "loadAvailableEmployees"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
  },
};
</script>

